// Django Rest Api connetion Utility

import axios from 'axios'
import config from "./config";

const baseURL = `${config.DJANGO_URL}`

const axiosInstance = axios.create({
    baseURL: baseURL,
    timeout: 600000,
    headers: {
        'Authorization': localStorage.getItem('access_token') ? "Bearer " + localStorage.getItem('access_token') : '',
        'Content-Type': 'application/json',
        'accept': 'application/json'
    }
});

export default axiosInstance

// ROS bag 파일 관련 API
export const rosbagAPI = {
  // 파일 목록 조회
  getFiles: () => axiosInstance.get('/raxigo/rosbags/'),
  
  // 파일 상세 조회
  getFile: (id) => axiosInstance.get(`/raxigo/rosbags/${id}/`),
  
  // 파일 업로드
  uploadFile: (formData, onProgress) => {
    return axiosInstance.post('/raxigo/rosbags/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: onProgress,
    });
  },
  
  // 파일 삭제
  deleteFile: (id) => axiosInstance.delete(`/raxigo/rosbags/${id}/`),
  
  // 파일 다운로드
  downloadFile: (id) => {
    return axiosInstance.get(`/raxigo/rosbags/${id}/download/`, {
      responseType: 'blob',
    });
  },
  
  // Ros1 토픽 정보 조회
  getRos1Topics: (formData) => {
    return axiosInstance.post('/raxigo/ros1/topics/', formData);
  },

  // Ros2 토픽 정보 조회
  getRos2Topics: (formData) => {
    return axiosInstance.post('/raxigo/ros2/topics/', formData);
  },
  
  // 통계 조회
  getStatistics: () => axiosInstance.get('/raxigo/rosbags/statistics/'),
};

// 파일 다운로드 헬퍼 함수
export const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

// 파일 크기 포맷팅
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

// 시간 포맷팅
export const formatDuration = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);
  
  if (hours > 0) {
    return `${hours}h ${minutes}m ${secs}s`;
  } else if (minutes > 0) {
    return `${minutes}m ${secs}s`;
  } else {
    return `${secs}s`;
  }
};